import type {CSSProperties} from 'react';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeBriefCooldownLook = 'brief-cooldown-prefill';

const BRIEF_COOLDOWN_LOOKS = new Set<string>(['brief-cooldown-prefill']);
export const isWedgeBriefCooldownLook = (look: string | undefined): look is WedgeBriefCooldownLook => look !== undefined && BRIEF_COOLDOWN_LOOKS.has(look);

/* Released brief cooldown action (the row under the research cooldown countdown). The prefill button is a full width inline flex
   box, 44px tall and centered, with an 8px top margin, the surface fill, the accent ink, a half pixel accent border, an 11px radius
   and 13.5px bold type in the Wedge font. It keeps the declaration order of the source and reads the exact legacy roles. It draws no
   transparent target and no anchor (wedgeSettingsDrawsHit): its own 44px floor already meets the target size, it spans the row, and
   a region above it would reach the countdown status line, which sits 8px away. */
export function wedgeBriefCooldownStyle(look: WedgeBriefCooldownLook): CSSProperties {
  const r = wedgeExactRole;
  switch (look) {
    case 'brief-cooldown-prefill': return {
      marginTop: 8, width: '100%', minHeight: 44,
      background: r('surface'), color: r('accent'),
      border: `0.5px solid ${r('accent')}`, borderRadius: 11,
      fontFamily: r('font'), fontSize: 13.5, fontWeight: 700, cursor: 'pointer',
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      WebkitTapHighlightColor: 'transparent', touchAction: 'manipulation',
    };
  }
}
